import StatusHandler from 'app/shared-components/StatusHandler'
import locationRequests from 'app/requests/Location.requests'
import SkyMindSync from 'app/shared-components/SkyMindSync'

import {
    useGetLocation,
} from '../hooks'

const SkyMindSyncContainer = ({
    id,
}: { id: number }) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetLocation(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <SkyMindSync
                requestParams={locationRequests.skyMindSyncUpdate({
                    id,
                })}
                skyMindId={data?.skyMindId}
                invalidate={invalidate}
            />
        </StatusHandler>
    )
}

export default SkyMindSyncContainer
